import { Box, Button, styled, TextField, Typography } from "@mui/material";

export const StyledContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "center", 
    alignItems: "center", 
    width: "60%",
    padding: theme.spacing(2),
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    backgroundColor: theme.palette.background.paper, 
    transition: "all 0.3s ease-in-out", 
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    marginLeft: theme.spacing(1), 
    height: "80%", 
    borderRadius: 8,
    fontWeight: 500,
    textTransform: "none",
}));

export const StyledInput = styled(TextField)(({ theme }) => ({
    flexGrow: 1, 
    marginRight: theme.spacing(1), 
    backgroundColor: theme.palette.background.paper, 
    "& .MuiOutlinedInput-root": {
        borderRadius: 8,
        padding: theme.spacing(0.5, 1),
    },
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
    textAlign: "center", 
    marginBottom: theme.spacing(3), 
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontSize: "1.125rem",
}));

export const StyledBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: theme.palette.background.default,
}));
export const StyledChatContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
})); 